import request from '@/utils/request'

// 查询秘书列表
export function getAllSecretary(params) {
  return request({
    url: 'secretary/search',
    method: 'post',
    data: params
  })
}
// 新增秘书配置
export function setSecretary(params) {
  return request({
    url: 'secretary',
    method: 'post',
    data: params
  })
}
// 获取单条配置
export function getDetail(id) {
  return request({
    url: 'secretary/' + id,
    method: 'get'
  })
}
// 编辑提交
export function editSecretary(params, id) {
  return request({
    url: 'secretary/edit/' + id,
    method: 'post',
    data: params
  })
}

// /api/meeting/attendeesSchedules
export function getAttendeesSchedules(params) {
  return request({
    url: 'meeting/attendeesSchedules',
    method: 'post',
    data: params
  })
}
